import { imageArrayPropType, themePropType } from './sharedPropTypes';
import PropTypes from 'prop-types';
import React from 'react';
import '../containerStyles.css';

export default function OCTemplate({ theme, name, image, description, onClick, index }) {
    const containerClass = `char-container ${index % 2 !== 0 ? 'reverse' : ''}`;
    
    return (
        <div className={containerClass} onClick={onClick}>
            <div className="char-txtContainer">
                <h3>{name}</h3>
                <p>{description}</p>
            </div>
            <div className="image-container">
                <img src={image} alt={name} />
            </div>
        </div>
    );
};

OCTemplate.propTypes = {
    theme: themePropType,
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    index: PropTypes.number.isRequired
};